<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chap-title1">CONTENTS</h1>
<p class="toc-head"><a href="#/Introduction">INTRODUCTION</a></p>
<p class="toc-head"><a href="#/Chapter1#C1">USING FUSE BEADS</a></p>
<p class="toc-text1"><a href="#/Chapter1#C1-1">Buying beads</a></p>
<p class="toc-text1"><a href="#/Chapter1#C1-2">Equipment</a></p>
<p class="toc-text1"><a href="#/Chapter1#C1-3">Creating a design</a></p>
<p class="toc-text1"><a href="#/Chapter1#C1-4">Ironing</a></p>
<p class="toc-text1"><a href="#/Chapter1#C1-5">Ironing choices</a></p>
<p class="toc-head"><span href="#/Chapter2#C2" title="Link target outside of Sample">MATERIALS AND EQUIPMENT</span></p>
<p class="toc-head"><span href="#/Chapter3#C3" title="Link target outside of Sample">BASIC TECHNIQUES</span></p>
<p class="toc-text1"><span href="#/Chapter3#C3-1" title="Link target outside of Sample">Using jump rings</span></p>
<p class="toc-text1"><span href="#/Chapter3#C3-2" title="Link target outside of Sample">Bending</span></p>
<p class="toc-text1"><span href="#/Chapter3#C3-3" title="Link target outside of Sample">Peyote stitch</span></p>
<p class="toc-text1"><span href="#/Chapter3#C3-4" title="Link target outside of Sample">Reading a peyote stitch chart</span></p>
<p class="toc-text1"><span href="#/Chapter3#C3-5" title="Link target outside of Sample">Joing peyote bands</span></p>
<p class="toc-head"><span href="#/Chapter4" title="Link target outside of Sample">DESIGNS</span></p>
<p class="toc-text2"><span href="#/Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-text2"><span href="#/Suppliers" title="Link target outside of Sample">Suppliers</span></p>
<p class="toc-text2"><span href="#/Author" title="Link target outside of Sample">About the author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7c7165d8